import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  variant: Yup.string().required('Variante é obrigatória').nullable(true),
  description: Yup.string().required('Descrição é obrigatória').nullable(true),
  sort_order: Yup.number().required('Ordem é obrigatória').nullable(true),
});

export default validationSchema;
